import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { Link } from 'foundations-components/transitional/components/Link';
import { DEAL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useAssociatedObjectsCardContentContext } from '../context/AssociatedObjectsCardContext';
import { CrmLogger } from 'customer-data-tracking/loggers';
import { useCallback } from 'react';
import { useIsEmbeddedContextV2 } from 'customer-data-sidebar/universal/context/IsEmbeddedContextV2';
import { View } from 'foundations-components/components/View';

// See https://hubspot.slack.com/archives/CSV1RTHM4/p1597176001336100?thread_ts=1597172557.330000&cid=CSV1RTHM4 for where these numbers came from
import { jsx as _jsx } from "react/jsx-runtime";
const associationCategories = {
  HUBSPOT_DEFINED: 0,
  USER_DEFINED: 1
};
const getHref = ({
  associationTypes,
  objectId,
  toObjectTypeId
}) => {
  const portalId = PortalIdParser.get();

  // We are guaranteed to have an unlabelled association type unless there
  // is a custom one to one association created pre-flexible-associations,
  // in which case we are guaranteed only one association
  // https://hubspot.slack.com/archives/C01B5SP6Y76/p1651167271938489?thread_ts=1651164281.065659&cid=C01B5SP6Y76
  const unlabeledInverseAssociationType = associationTypes.find(associationType => associationType.inverseHasAllAssociatedObjects) || associationTypes[0];
  const associationCategoryNumber =
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  associationCategories[unlabeledInverseAssociationType.associationCategory];
  const filters = encodeURIComponent(JSON.stringify([{
    operator: 'EQ',
    value: objectId,
    property: `associations.${associationCategoryNumber}-${unlabeledInverseAssociationType.inverseAssociationTypeId}`
  }]));
  let queryString = `filters=${filters}`;
  if (toObjectTypeId === DEAL_TYPE_ID) {
    queryString += '&pipelineId=all';
  }
  return `/contacts/${portalId}/objects/${toObjectTypeId}/views/all/list?${queryString}`;
};
const getMessageProps = ({
  associationTypes,
  total
}) => {
  const objectName = total === 1 ? associationTypes[0] && associationTypes[0].toObjectTypeDefinition && associationTypes[0].toObjectTypeDefinition.singularForm : associationTypes[0] && associationTypes[0].toObjectTypeDefinition && associationTypes[0].toObjectTypeDefinition.pluralForm;
  const options = {
    count: total,
    associationToPlural: objectName || ''
  };
  return {
    options
  };
};
const getObjectTypeHasViewPermissions = (hasScope, associationTypes) => {
  if (associationTypes[0] && associationTypes[0].toObjectTypeDefinition && associationTypes[0].toObjectTypeDefinition.permissioningType === 'ALL_OR_NONE') {
    return hasScope(associationTypes[0] && associationTypes[0].toObjectTypeDefinition && associationTypes[0].toObjectTypeDefinition.readScopeName || '');
  }
  return true;
};
const ViewXObjectsLink = () => {
  var _associationsData$imp, _associationsData$imp2;
  const {
    associationTypesData,
    hasScope,
    objectId,
    associationsData,
    toObjectTypeId
  } = useAssociatedObjectsCardContentContext();
  const {
    associationTypes
  } = associationTypesData;
  const href = getHref({
    associationTypes,
    objectId,
    toObjectTypeId
  });
  const total = (_associationsData$imp = (_associationsData$imp2 = associationsData.impliedUnlabeledAssociationObjects) === null || _associationsData$imp2 === void 0 ? void 0 : _associationsData$imp2.total) !== null && _associationsData$imp !== void 0 ? _associationsData$imp : 0;
  const messageProps = getMessageProps({
    associationTypes,
    total
  });
  const objectTypeHasViewPermissions = getObjectTypeHasViewPermissions(hasScope, associationTypes);
  const handleTrackViewAllAssociatedObjects = useCallback(() => {
    CrmLogger.log('sidebar-interaction', {
      type: toObjectTypeId,
      action: 'view all associated objects'
    });
  }, [toObjectTypeId]);
  const {
    openLinkExternal
  } = useIsEmbeddedContextV2();
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: objectTypeHasViewPermissions,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: total === 1 ? 'cardAssociatedObjects.AssociatedObjectsCardPaginator.noViewAccessSingular' : 'cardAssociatedObjects.AssociatedObjectsCardPaginator.noViewAccessPlural'
    }),
    "data-selenium-test": "view-x-objects-tooltip",
    "data-test-id": "view-x-objects-tooltip",
    placement: "right",
    children: /*#__PURE__*/_jsx(View, {
      minInlineSize: "0",
      children: /*#__PURE__*/_jsx(Link, {
        href: href,
        "data-selenium-test": "view-x-objects-link",
        "data-test-id": "view-x-objects-link",
        truncate: true,
        disabled: !objectTypeHasViewPermissions,
        onClick: handleTrackViewAllAssociatedObjects,
        external: openLinkExternal,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardAssociatedObjects.AssociatedObjectsCardPaginator.viewAllAssociated",
          options: messageProps.options
        })
      })
    })
  });
};
export default ViewXObjectsLink;